import { useUserSettingsQuery } from '#pplx/frontend/apps/ask/user-settings/hooks/useUserSettingsQuery.js';
import { useMemo } from 'react';
const EMPTY_CONNECTORS_MAP = Object.freeze({});
export const useConnectorsMap = ({ reason, enabled = true, skipConnectorPickerCredentials = true, }) => {
    const { connectors, hasLoadedSettings } = useUserSettingsQuery({
        reason,
        enabled,
        skipConnectorPickerCredentials,
    });
    const connectorsMap = useMemo(() => {
        if (!connectors?.connectors?.length)
            return EMPTY_CONNECTORS_MAP;
        return connectors.connectors.reduce((accumulator, connector) => {
            accumulator[connector.name] = connector;
            return accumulator;
        }, {});
    }, [connectors]);
    return useMemo(() => ({
        connectorsMap,
        hasLoadedSettings,
    }), [connectorsMap, hasLoadedSettings]);
};
//# sourceMappingURL=useConnectorsMap.js.map